export default __webpack_public_path__ + "edb41c7117a9924861b88cc0055fcd8a.svg";